'use strict';

var React = require('react');

var SvgFirstOrderMajor = function SvgFirstOrderMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.72 4.28a.75.75 0 0 1 1.06-1.06l.5.5a.75.75 0 0 1-1.06 1.06l-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.013 7.462a.75.75 0 1 1 .474-1.424l1.5.5a.75.75 0 1 1-.474 1.424l-1.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.28 3.22a.75.75 0 0 1 0 1.06l-.5.5a.75.75 0 1 1-1.06-1.06l.5-.5a.75.75 0 0 1 1.06 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.462 6.513a.75.75 0 0 1-.475.949l-1.5.5a.75.75 0 0 1-.474-1.424l1.5-.5a.75.75 0 0 1 .949.475Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.751 5.687-.493 3.457a.75.75 0 0 0 1.485.212l.715-5.01c.107-.75-.745-1.255-1.351-.801l-1.807 1.355a.75.75 0 0 0 .9 1.2l.551-.413Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m5.156 10 .132-.89a.75.75 0 1 0-1.484-.22l-.21 1.417a8.749 8.749 0 0 0-.094 1.282v1.661a3.25 3.25 0 0 0 3.25 3.25h6.5a3.25 3.25 0 0 0 3.25-3.25v-1.66c0-.43-.032-.858-.095-1.283l-.21-1.417a.75.75 0 0 0-1.483.22l.132.89h-2.484a1.25 1.25 0 0 0-1.185.855l-.159.474a.25.25 0 0 1-.237.171h-1.558a.25.25 0 0 1-.237-.17l-.159-.475a1.25 1.25 0 0 0-1.185-.855h-2.484Zm-.155 1.5-.001.09v1.66c0 .967.784 1.75 1.75 1.75h6.5a1.75 1.75 0 0 0 1.75-1.75v-1.75h-2.46l-.1.303a1.75 1.75 0 0 1-1.66 1.197h-1.56a1.75 1.75 0 0 1-1.66-1.197l-.1-.303h-2.46Z"
  }));
};
SvgFirstOrderMajor.displayName = "FirstOrderMajor";

exports.SvgFirstOrderMajor = SvgFirstOrderMajor;
